import Vue from 'vue'
import VueRouter from 'vue-router'
import DateAgreement from '../views/configurator-views/DateAgreement'
import Calculator from '../views/configurator-views/Calculator'
import Summary from '../views/configurator-views/Summary'
import Home from '../views/Home'
import Login from '../views/Login'
import Logout from '../views/Logout'
import OrderList from '../views/crm-views/OrderList'
import OrderPreview from '../views/crm-views/OrderPreview'
import Users from '../views/crm-views/Users'
import UserProfile from '@/views/crm-views/UserProfile'
import Roles from '../views/crm-views/Roles'
import Verify from '../views/Verify'
import ForgotPassword from '../views/ForgotPassword'
import ChangeEmailVerify from '@/views/ChangeEmailVerify'
import ResetPasswordVerify from '@/views/ResetPasswordVerify'

Vue.use(VueRouter)

const routes = [
  {
    path: '/date',
    name: 'date',
    meta: { layout: 'empty' },
    component: DateAgreement,
  },
  {
    path: '/calc',
    name: 'calc',
    meta: { layout: 'empty' },
    component: Calculator,
  },
  {
    path: '/summary',
    name: 'summary',
    meta: {
      layout: 'empty',
    },
    component: Summary,
  },
  {
    path: '/',
    name: 'home',
    props: true,
    meta: {
      layout: 'empty',
    },
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'login',
      requiresVisitor: true,
    },
    component: Login,
  },
  {
    path: '/reset',
    name: 'reset',
    meta: {
      layout: 'login',
      requiresVisitor: true,
    },
    component: ForgotPassword,
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      layout: 'login',
    },
    component: Logout,
  },
  {
    path: '/users',
    name: 'Użytkownicy',
    meta: {
      layout: 'crm',
      requiresAuth: true,
    },
    component: Users,
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      layout: 'login',
    },
    component: Verify,
  },
  {
    path: '/roles',
    name: 'Role i uprawnienia',
    meta: {
      layout: 'crm',
      requiresAuth: true,
    },
    component: Roles,
  },
  {
    path: '/orders/',
    name: 'Lista zamówień',
    meta: {
      layout: 'crm',
      requiresAuth: true,
    },
    component: OrderList,
  },
  {
    path: '/order/:id',
    name: 'Podgłąd zamówienia',
    props: true,
    meta: {
      layout: 'crm',
      requiresAuth: true,
    },
    component: OrderPreview,
  },
  {
    path: '/profile',
    name: 'Profil',
    props: true,
    meta: {
      layout: 'crm',
      requiresAuth: true,
    },
    component: UserProfile,
  },
  {
    path: '/verifyEmailChange',
    name: 'Veryfikacja zmiany mailu',
    props: true,
    meta: {
      layout: 'login',
    },
    component: ChangeEmailVerify,
  },
  {
    path: '/verifyPasswordReset',
    name: 'Veryfikacja resetu hasła',
    props: true,
    meta: {
      layout: 'login',
    },
    component: ResetPasswordVerify,
  },

  // component: () =>
  //   import(/* webpackChunkName: "about" */ "../views/About.vue")
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
